module.exports = __webpack_public_path__ + "img/speedometer.b3eb650f.svg";